<template>
    <div class="carrier-info">
      <div class="info-box">
        <div class="info-item">
          <strong>Carrier Name:</strong>
          <p>{{ carrierName }}</p>
        </div>
        <div class="info-item">
          <strong>Contact Name:</strong>
          <p>{{ contactName }}</p>
        </div>
        <div class="info-item">
          <strong>Email:</strong>
          <p>{{ email }}</p>
        </div>
        <div class="info-item">
          <strong>Phone:</strong>
          <p>{{ phone }}</p>
        </div>
        <div class="info-item">
          <strong>Physical Address:</strong>
          <p>{{ physicalAddress }}</p>
        </div>
        <div class="info-item">
          <strong>Mailing Address:</strong>
          <p>{{ mailingAddress }}</p>
        </div>
      </div>
      <div class="info-box">
        <div class="info-item">
          <strong>Type of Hauling:</strong>
          <p>{{ haulingType }}</p>
        </div>
        <div class="info-item">
          <strong>Authority Type:</strong>
          <p>{{ authorityType }}</p>
        </div>
        <div class="info-item">
          <strong>Owner Name:</strong>
          <p>{{ contactName }}</p>
        </div>
        <div class="info-item">
          <strong>Owner DOB:</strong>
          <span v-if="!ownerDOB" style="color: red; font-size: 18px;">* </span><span v-if="!ownerDOB">(Please provide this info by clicking Request Changes)</span>
          <p v-if="ownerDOB">{{ ownerDOB }}</p>
        </div>
      </div>
     
      <div class="actions">
        <button class="request-changes" @click="navigateToCarrierInfo"><i class="pi pi-pencil"></i> Request Changes</button>
        <button class="info-correct" @click="InfoisCorrect"><i class="pi pi-check" style="font-weight: bold;"></i> Info is Correct</button>
      </div>
      <p class="note">
        Please note that this does not initiate any changes to your current active policy.
      </p>
    </div>
  </template>
  
  <script>
  export default {
  name: 'CarrierInformation',
  data() {
    return {
      carrierName: '',
      contactName: '',
      email: '',
      phone: '',
      physicalAddress: '',
      mailingAddress: '',
      haulingType: '',
      authorityType: '',
      ownerDOB: null
    };
  },
  mounted() {
    // Retrieve data from localStorage
    const storedData = localStorage.getItem('deruloData');
    if (storedData) {
      const data = JSON.parse(storedData);
      const contactInfo = data.contact_info[0];
      const address = data.address;

      this.carrierName = contactInfo.named_insured || 'N/A';
      this.contactName = data.primary_contact || 'N/A';
      this.email = data.primary_email || 'N/A';
      this.phone = data.primary_phone || 'N/A';
      this.physicalAddress = `${address[1].street}, ${address[1].city}, ${address[1].state}, ${address[1].zip}`;
      this.mailingAddress = `${address[0].street}, ${address[0].city}, ${address[0].state}, ${address[0].zip}`;
      this.haulingType = data.hauling_type || 'N/A';
      this.authorityType = data.authority_type || 'N/A';

      if(data.drivers) {
        let drivers = data.drivers;
        drivers.forEach(driver => {
          if(driver.driver_name == this.contactName) {
            this.ownerDOB = driver.birth_date
          }   
        })
      } else {
        console.error('No Drivers in data');
      }

    } else {
      console.error('No data found in localStorage');
    }

  },
  methods: {
    navigateToCarrierInfo() {
      this.$router.push({
      path: '/carrierchanges'
    });
    },
    InfoisCorrect() {
      localStorage.setItem('carrier_changes', 'No Changes Requested');
      const scrollPosition = window.pageYOffset || document.documentElement.scrollTop;
      sessionStorage.setItem('scrollToTop', 'true');
      sessionStorage.setItem('previousScrollPosition', scrollPosition);
      this.$router.push({
      path: '/coverageinfo'
    });
    },
  }
};
  </script>
  <style scoped>

  i {
    margin-right: 5px;
  }

  .carrier-info {
    background-color: white;
    padding: 0px;
    margin: 0px;
    width: 100%;
    max-width: 800px;
    box-shadow: 0 0 10px rgba(0, 0, 0, 0.1);
    border-radius: 5px;
    text-align: left;
    border: 1px solid #ddd;
  }
  
  h2 {
    color: #333;
    text-align: center;
    margin-bottom: 20px;
  }
  
  .info-box {
    margin: 5px 10px;
    display: flex;
    flex-direction: column;
    margin-bottom: 10px;
    border: 2px solid #ddd;
    border-radius: 10px;
    
  }
  .info-item {
    padding: 10px;
    border-radius: 5px;
  }
  .info-item strong {
    display: block;
    margin-bottom: 5px;
    color: #333;
  }
  .info-item p {
    margin: 0;
    color: #666;
  }
  .info-item span {
    margin: 0;
    color: #666;
  }
  
  .actions {
    display: flex;
    text-align: center;
    margin-top: 10px;
    justify-content: center;
  }
  
  button {
    padding: 10px 20px;
    margin: 0 10px;
    border: none;
    border-radius: 5px;
    cursor: pointer;
    font-size: 16px;
  }
  
  .request-changes {
    background-color: #004d40;
    color: white;
  }
  
  .info-correct {
    background-color: #72933d;
    color: black;
  }
  
  .note {
    text-align: center;
    color: #777;
    margin-top: 10px;
  }

  @media (min-width: 1000px) {
    .carrier-info {
      width: 550px !important;
    }
  }
  </style>
  